import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../components/Button';
import './Welcome.scss';

const Welcome = () => {
  const navigate = useNavigate();

  const navigateToLogin = () => {
    navigate('/login');
  };

  return (
    <div className="welcome-wrapper">
      <header className="welcome-header">Welcome</header>
      <img src="images/welcome.png" alt="Welcome" className="welcome-image" />
      <Button className="btn-lg" onClick={navigateToLogin}>
        Sign In
      </Button>
    </div>
  );
};

export default Welcome;
